import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { errorsInput } from 'src/consts';
import { addPlusOnPhone, isPhoneValid } from 'src/helpers';
import * as Yup from 'yup';
import { CreateNewUserInputs } from '../users.types';

export const useCreateUserForm = () => {
  const { t } = useTranslation();

  const schema = Yup.object().shape({
    firstName: Yup.string().required(t('forms.required-field')),
    lastName: Yup.string().required(t('forms.required-field')),
    tel: Yup.string()
      .nullable()
      .required(t('forms.required-field'))
      .test('phone', t('forms.invalid-phone-format'), (value: string | null | undefined) => {
        if (!value) {
          return false;
        }

        const result = isPhoneValid(addPlusOnPhone(value));
        return result;
      }),
    email: Yup.string().nullable().required(errorsInput.required).email(t(errorsInput.emailInvalidFormat)),
    address: Yup.string().nullable(),
    password: Yup.string()
      .required(errorsInput.required)
      .test('len', t(errorsInput.minLengthPassword, { min: 8 }), (val) => !!val && val.length >= 8),
    passwordConfirmation: Yup.string()
      .required(errorsInput.required)
      .oneOf([Yup.ref('password')], t(errorsInput.matchPassword)),
    role: Yup.string().required(t('forms.required-field')),
  });

  const {
    handleSubmit,
    control,
    formState: { isDirty, errors },
  } = useForm<CreateNewUserInputs>({
    resolver: yupResolver(schema),
  });

  return {
    handleSubmit,
    control,
    isDirty,
    errors,
  };
};
